<script>
import BubbleSVG from '@/static/svg/preloader.svg';
import {TimelineMax, TweenMax, Expo, Back} from 'gsap/TweenMax';
import { mapGetters } from 'vuex';
import config from '@/config';

export default {
  name: 'Preloader',
  components: {
    BubbleSVG,
  },
  data () {
    return {
    }
  },
  computed: {
     ...mapGetters({
      progression: 'Preload/progression',
      locale: 'I18n/locale',
    }),
    complete() {
      return this.$store.getters['Preload/hasPreload']('Landing');
    }
  },
  watch: {
    complete() {
      TweenMax.to(this.$refs.Progress, 1, {scale:.9, alpha:0, ease:Expo.easeInOut});
      TweenMax.to(this.$refs.Bubble, 1, {scale:.45, alpha:0, ease:Expo.easeInOut, delay:.1, onComplete:() => {
        this.$store.commit('App/SET_READY');
      }});
    }
  },
  mounted() {
    this.$nextTick( () => {
      this.init()
    });
  },
  methods: {
    init() {
      config.ga('autoBegin', this.locale);
      
      const timeline = new TimelineMax({
        delay: .8
      });

      timeline
        .fromTo(this.$refs.Bubble, 1, {alpha:0, scale:.45}, {scale: 0.5, alpha:1, ease: Expo.easeInOut}, "start")
        .from(this.$refs.Progress, 1, {alpha:0, scale:1.2, ease:Expo.easeInOut, delay:.2, onComplete: () => {
          this.$store.dispatch("Preload/START", 'Landing')
        }}, "start")
        .to(this.$refs.Bubble, 2.3, {scale:.45, ease:Back.easeInOut.config(2), repeat: -1, repeatDelay:0, yoyo: true, transformOrigin: 'center center'});
    }
  }
}
</script>

<template>
  <div class='preloader-wrapper'>
    <BubbleSVG class='bubble' ref="Bubble" />
    <span ref="Progress" class='percent'>{{ Math.round(progression) }}</span>
  </div>  
</template>

<style scoped lang="scss">
.preloader-wrapper {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: $z-index-preloader;
  @include flexbox(center-vertical);

  @include landscape {
    display: none;
  }
}

.bubble {
  position: absolute;
  align-items: center;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  transform: scale(0.5);
}

.percent {
  @include font($ff-double-medium, 1.4rem, $c-shamrock, 1.4rem);
}
</style>
